import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { PasswordInput } from "@freightsimple/ui-core/Controls/PasswordInput";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { CreateAccountErrorMessages } from "@/Shared/Authentication/Hooks/useAuthenticationCreateAccount";
import { AccountType } from "@/Shared/Authentication/Hooks/useAuthenticationCreateAccount";
import { authenticationPasswordGuidance } from "@/Shared/Authentication/Bubbles/AuthenticationPasswordGuidanceBubble";

interface CreateAccountPageEmailAndPasswordProps {
  accountType: AccountType | undefined;
  email: string;
  setEmail: (_: string) => void;
  password: string;
  setPassword: (_: string) => void;
  forceValidation: boolean;
  errorMessages: CreateAccountErrorMessages;
}

export function AuthenticationCreateAccountPageEmailAndPassword(
  props: CreateAccountPageEmailAndPasswordProps,
) {
  const {
    accountType,
    email,
    setEmail,
    password,
    setPassword,
    forceValidation,
    errorMessages,
  } = props;

  if (accountType === undefined) {
    return <></>;
  }

  const emailLabel =
    accountType === AccountType.Personal
      ? "Tell us your email address"
      : "Tell us your work email address";

  return (
    <ShowFormErrors show={forceValidation}>
      <Stack gap={5}>
        <FormItem
          label={emailLabel}
          fillWidth
          emphasizeLabel
          error={errorMessages.email}
        >
          <TextInput
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            name="signup_email"
            width="full"
            placeholder="you@company.com"
          />
        </FormItem>
        <FormItem
          label="Choose your password"
          tooltip={authenticationPasswordGuidance}
          fillWidth
          emphasizeLabel
          error={errorMessages.password}
        >
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            name="signup_password"
            width="full"
            placeholder="Enter your new password"
          />
        </FormItem>
      </Stack>
    </ShowFormErrors>
  );
}
